import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider, useDispatch } from 'react-redux'
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { saveState } from './data/local-storage';

window.broadbandDecider = store;
const domContainerId = 'service-recommender-frontend';
var domCounter = 0;
// use the id, but if its already been initialized,
// then try incrementing it (allow for multiple on same page)
do {
	var domContainer = domCounter > 0 ? document.getElementById(`${ domContainerId }-${ domCounter }`) : document.getElementById( domContainerId );
	domCounter++;
} while ( domContainer && domContainer._reactRootContainer );

const props = domContainer.dataset.props ? JSON.parse( domContainer.dataset.props ) : {};
window.jQuery( function(){
	if ( Object.keys(props).length === 0 ){
		if ( domContainer.dataset.restendpoint ){
			store.dispatch({
				type: 'load_from_endpoint',
				payload: {
					restendpoint: domContainer.dataset.restendpoint,
					rootId: domContainer.id
				}
			});
		}
	} else {
		store.dispatch({
			type: 'load',
			payload: Object.assign({}, props, {
				rootId: domContainer.id
			})
		});
	}
})
store.subscribe( () => {
	saveState(store.getState());
});

ReactDOM.render(
	<Provider store={ store } >
    	<App {...props}/>
	</Provider>,
	domContainer
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// import { saveState } from './data/local-storage'
// import store from './redux/store'
// import { refreshAll } from './redux/actions'

// import { Provider, useDispatch } from 'react-redux'

// store.subscribe( () => {
// 	saveState(store.getState());
// });
// if ( store.getState().isLoading ){
// 	store.dispatch( refreshAll() );
// }
// window.store = store;
// window.api = api;



